var _rect, _rect2, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalTradesV2Light(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 60,
    height: 60,
    rx: 16,
    fill: "url(#paint0_linear_10771_44865)",
    fillOpacity: 0.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16663,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 15.5,
    stroke: "#0D1A16",
    strokeOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5871 16.3201V19.2001H41.5302L37.5365 23.5932L34.7071 20.7638L26.7871 28.6838L23.9549 25.8516L15.0182 33.9741L16.956 36.106L23.8593 29.8285L26.7871 32.7563L34.7071 24.8363L37.6363 27.7655L43.3471 21.4852V24.9601H46.2271V16.3201H37.5871ZM41.9071 28.5601V43.6801H44.7871V28.5601H41.9071ZM31.8271 30.7201V43.6801H34.7071V30.7201H31.8271ZM36.8671 30.7201V43.6801H39.7471V30.7201H36.8671ZM21.7471 34.3201V43.6801H24.6271V34.3201H21.7471ZM26.7871 35.0401V43.6801H29.6671V35.0401H26.7871ZM16.7071 37.9201V43.6801H19.5871V37.9201H16.7071Z",
    fill: "#F2AE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9067 28.56V43.68H44.7867V28.56H41.9067ZM31.8267 30.72V43.68H34.7067V30.72H31.8267ZM36.8667 30.72V43.68H39.7467V30.72H36.8667ZM21.7467 34.32V43.68H24.6267V34.32H21.7467ZM26.7867 35.04V43.68H29.6667V35.04H26.7867ZM16.7067 37.92V43.68H19.5867V37.92H16.7067Z",
    fill: "#02B37F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10771_44865",
    x1: 9.66663,
    y1: 2,
    x2: 60.6666,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTradesV2Light);
export default __webpack_public_path__ + "static/media/totalTradesV2Light.65d77378914afe133a055ff9623e3412.svg";
export { ForwardRef as ReactComponent };